import React from 'react';
/**
 * tree 树相关工具类
 * @Author gufuyan
 * @Date 2018-08-29
 */
class TreeFn {
    //函数参数默认值
    constructor(idName = "id", fIdName = "fId") {
        this.idName = idName;
        this.fIdName = fIdName;
    }

    /**
     * 根据结构id和fId生成树
     * @param treeArr 生产树的对象，必须有关键属性id和fId
     * @param idName  指id的属性名
     * @param fIdName 指fId的属性名
     * renderTree 和 getTreeList 不同写法，结果一样
     * @returns {Array}
     */
    renderTree = (treeArr = [], idName = "id", fIdName = "fId") => {
        let tree = [];
        let newTreeArr = [];

        //过滤掉所有父id的不存在的节点，返回fid存在的所有节点item[fIdName]
        newTreeArr = treeArr.filter((item, index) => {
            !item[fIdName] && tree.push(item); //tree  取到所有根节点
            return item[fIdName]; //newTreeArr 返回去掉根节点的所有数组
        });

        let setTreeData = (_newTreeArr, _tree) => {
            let newTreeArr = _newTreeArr.filter((treeArrItem, index) => {
                //剩下的每一项数组 去查找已存在的目录树，查找得到添加进去，查找不到继续留着
                let renderFlag = (treeArrItem, _tree) => {
                    for (let o of _tree) {
                        if (treeArrItem[fIdName] == o[idName]) {
                            let childList = o.childList || [];
                            childList.push(treeArrItem);
                            o.childList = childList;
                            return true
                        } else {
                            if (o.childList && o.childList.length) {
                                let resChildListFlag = renderFlag(treeArrItem, o.childList);
                                if (resChildListFlag) return resChildListFlag
                            }
                        }
                    }
                };
                let flag = renderFlag(treeArrItem, _tree);
                //如果查找得到fid,  flag为true，需返回查找不到的所有项 !flag
                return !flag
            });
            if (newTreeArr.length) {
                setTreeData(newTreeArr, _tree);
            }
        };

        setTreeData(newTreeArr, tree);

        return tree;
    };

    /**
     * 根据结构id和fId生成树
     * @param list  生产树的对象，必须有关键属性id和fId
     * @param idName  指id的属性名
     * @param pidName 指fId的属性名
     * @returns {Array}
     */
    getTreeList = (list = [], idName = "id", fIdName = "fId") => {

        let obj = {};
        let tree = [];

        let setTree = (fo, idName) => {
            if (fo.childList) {
                for (let foo of fo.childList) {
                    let idd = foo[idName];
                    if (obj[idd]) {
                        foo.childList = [];
                        foo.childList = obj[idd];
                        setTree(foo, idName);
                    }
                }
            }
        };

        for (let o of list) {
            if (!obj[o[fIdName]]) {
                obj[o[fIdName]] = [];
            }
            if (o[fIdName] == null) {
                tree.push(o);
            }
            obj[o[fIdName]].push(o);
        }

        //父id开头
        for (let fo of tree) {
            let _idName = fo[idName];
            if (obj[_idName]) {
                fo.childList = [];
                fo.childList = obj[_idName];
            }
        }

        for (let fo of tree) {
            setTree(fo, idName);
        }

        return tree;

    };

    /**
     * 获取根据id获取fid
     * @param tree
     * @param id
     * @returns {Array}
     */
    getFId = (tree, id, idName = "id", childList = 'childList') => {
        let arrIds = [];
        let arrList = [];
        const getId = (obj, id) => {
            let oStr = JSON.stringify(obj);
            if (oStr.indexOf(':' + id + ',') != -1) {
                if (typeof obj == "object") {
                    if (obj[idName] == id) {
                        arrIds.push(obj[idName]);
                        arrList.push(obj);
                        // arrIdList.push(obj)
                    } else if (obj[idName]) {
                        arrIds.push(obj[idName]);
                        arrList.push(obj);
                        if (obj[childList] && obj[childList].length) {
                            for (let o of obj[childList]) {
                                getId(o, id)
                            }
                        }
                    } else {
                        if (obj[childList] && obj[childList].length) {
                            for (let o of obj[childList]) {
                                getId(o, id)
                            }
                        }
                    }
                }
            }
        };
        for (let o of tree) {
            getId(o, id);
        }
        return {
            arrIds,
            arrList
        }
    };

    /**
     * 场景太多，后面再补上此功能
     * @param tree
     * @param id
     * @param idName
     * @returns {{arrIds: Array, arrList: Array}}
     */
    getCId = (tree, id, idName = "id") => {
        //功能尚未完成
        let arrIds = [];
        let arrList = [];
        // let loopTree = (data, id)=> {
        //     if (data instanceof Array) {
        //         for (let o of data) {
        //             loopTree(o)
        //         }
        //     } else {
        //         if (!choArr.in_array(data[idText])) {
        //             choArr.push(data[idText]);
        //             choData.push(data);
        //         }
        //         if (!choChlArr.in_array(data[idText])) {
        //             choChlArr.push(data[idText]);
        //             choChlData.push(data);
        //         }
        //         if (data.subList && data.subList.length) {
        //             loopTree(data.subList)
        //         }
        //     }
        // };
        // loopTree(tree, id, "");
        return {
            arrIds,
            arrList
        }
    };

    /**
     * 根据输入值 搜索 树
     * @param value 输入的值
     * @param dataSource 树
     * @param searchName 输入的值对应树的属性名称
     * @param childList 子集的属性名称
     * @returns {Array}
     */
    getSearch = (value, dataSource, searchName = "orgName", childList = "subList") => {
        let searchData = [];
        const randerSearch = (value, dataSource) => {
            if (dataSource instanceof Array) {
                for (let item of dataSource) {
                    let orgName = item[searchName];
                    if (value && orgName.includes(value)) {
                        searchData.push(item)
                    }
                    if (item[childList] && item[childList].length) {
                        randerSearch(value, item[childList], searchData)
                    }
                }
            }
        };
        randerSearch(value, dataSource);
        return searchData
    };

    /**
     *
     * @param deptArr
     * @param personArr
     * @param idName
     * @param fIdName
     * @returns {Array}
     */
    renderDepartmentStaff = (deptArr = [], personArr = [], idName = "id", fIdName = "fId") => {

        const deptTree = this.renderTree(deptArr, idName, fIdName);
        /**
         * 根据 部门ID，获取所有人员满足部门ID的集合
         * @param deptId
         * @param idName
         * @returns {Array}
         */
        const getPersonByDeptId = (deptId, idName) => {
            //为了下次遍历 人员数据越来越少
            const newPersonArr = [];
            const deptIdPerson = [];
            personArr.forEach((item, index)=> {
                if (item[idName] == deptId) {
                    deptIdPerson.push(item)
                } else {
                    newPersonArr.push(item)
                }
            });
            // const deptIdPerson = personArr.filter((item,index)=>{
            //    return item.deptId == deptId
            //  })
            personArr = newPersonArr;
            return deptIdPerson
        };

        /**
         *
         * @param obj 没条数据 {}/[{}]
         * @param idName
         */
        const renderDP = (obj, idName) => {
            if (obj instanceof Array) {
                for (const o of obj) {
                    o.type == "dept" && renderDP(o, idName)
                }
            } else {
                if (obj[idName] && obj.type == "dept") {
                    if (!obj.childList) {
                        obj.childList = []
                    }
                    let deptIdPerson = getPersonByDeptId(obj[idName], idName);
                    obj.childList = deptIdPerson.concat(obj.childList || [])
                }
                if (obj.childList && obj.childList.length > 0) {
                    renderDP(obj.childList, idName)
                }
            }
        };
        for (const o of deptTree) {
            renderDP(o, idName);
        }

        return deptTree

    };


}

let _Tree = new TreeFn();

export {_Tree}


